import { Injectable } from '@angular/core';
import { Http, Headers, Response, ResponseContentType } from '@angular/http';
import { ServiceGuard } from '../_guards/service.guard';
import { EnvSpecific } from '../environs/models/env-specific';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { EnvironmentSpecificService } from '../environs/services/environment-specific.service';
import { PeopleData } from '../gdpr/gdpr.model';

@Injectable()
export class GiftCardService {
  constructor(private readonly _http: Http, private readonly httpClient: HttpClient, private readonly _serviceGuard: ServiceGuard,
    private readonly ess: EnvironmentSpecificService) { }

  getContactId(envSpecific: EnvSpecific, hashCode: string) {
    return this._http
      .get(envSpecific.orionServiceUrl + '/contacts/v2/gdpr/contactHash?hashCode=' + hashCode, {
        headers: this._serviceGuard.authJsonHeaders()
      })
      .map((response: Response) => response.json());
  }

  async getApiKey(envSpec: any, callback: (apiKey: string) => void) {
    const body = new URLSearchParams();
    const { client_id, client_secret, scope, grant_type, tokenUrl } = envSpec;
    body.set('client_id', client_id);
    body.set('client_secret', client_secret);
    body.set('scope', scope);
    body.set('grant_type', grant_type);
    this._http.post(tokenUrl, body.toString(), { headers: this._serviceGuard.authTokenHeaders() }).subscribe({
      next: res => {
        const resStr = res['_body'] || '{"access_token":"", "token_type":""}';
        const json = JSON.parse(resStr);
        const apiKey = `${json.token_type} ${json.access_token}`;
        callback(apiKey);
      },
      error: error => {
        console.error('There was an error!', error);
        callback('');
      }
    });
  }
  async fetchToken(callback: (isSuccess: boolean) => void) {
    if (!sessionStorage.getItem('bearer_token')) {
      const envSpec = await this.ess.getEnvSpecific();
      this.getApiKey(envSpec, (apiKey) => {
        if (apiKey) {
          sessionStorage.setItem('bearer_token', apiKey);
          callback(true);
        } else {
          console.log('Error in getting api key');
          sessionStorage.setItem('bearer_token', '');
          callback(false);
        }
      });
    } else {
      callback(true);
    }
  }

  async getContactIdV2(hashCode: string, callback: (data) => void) {
    const envSpec = await this.ess.getEnvSpecific();
    const url = `${envSpec.getUrl}${hashCode}`;
    this.getApiKey(envSpec, (apiKey) => {
      const headers = new HttpHeaders({
        'Authorization': apiKey
      });
      this.httpClient.get(url, { headers }).subscribe({
        next: res => {
          console.log(res);
          const tdata: any = res || [];
          if (tdata.length > 0) {
            callback(tdata[0]);
          } else {
            callback('');
          }
        },
        error: error => {
          console.error('There was an error!', error);
          callback('');
        }
      });
    });
  }
  async postPeopleData(peopleData: PeopleData, callback: (data) => void) {
    const envSpec = await this.ess.getEnvSpecific();
    const url = envSpec.postUrl;
    this.getApiKey(envSpec, (apiKey) => {
      if (apiKey) {
        const headers = new HttpHeaders({
          'Authorization': apiKey
        });
        this.httpClient.post(url, peopleData, { headers }).subscribe({
          next: data => {
            callback(true);
          },
          error: error => {
            console.error('There was an error!', error);
            callback('');
          }
        });
      }
    });
  }
}
